import { Text } from '@vouched.id/vault';
import React from 'react';
import { AAMVADropdowns } from '../AAMVA/AAMVADropdowns';
import { AMLDropdowns } from '../AML/AMLDropdowns';
import { CrossCheckDropdowns } from '../CrossCheck/CrossCheckDropdowns';
import { DLVDropdown } from '../DLV/DLVDropdown';
import { DebugDropdowns } from '../Debug/DebugDropdowns';
import { FilesDropdown } from '../Files/FilesDropdown';
import { IPDropdown } from '../IP/IPDropdown';
import { IdDocument } from '../IdDocument/IdDocument';
import { LocationDropdowns } from '../Location/LocationDropdowns';
import { NISTDropdown } from '../NIST/NISTDropdown';
import { RerunJobDropdown } from '../RerunJob/RerunJobDropdown';
import { ReviewDropdowns } from '../Review/ReviewDropdowns';
import { ScoresDropdown } from '../Scores/ScoresDropdown';
import { useJobSectionTitleStyles } from '../utils';
import { roundNumber } from 'utils/ui.utils';
export const IDVDropdowns = ({ job, jobErrors, jobRequestInfo, jobRequestParams, jobRequestProperties, jobSid, jobStatus, jobResult, jobDebugResults, crossCheckResult, crossCheckSubmittedData, debugDropdownVisible, filesDropdownVisible, rejectionReasons, jobReview, onReviewSubmitted }) => {
    const idAddress = jobResult?.idAddress;
    const ipAddress = jobResult?.ipAddress;
    const confidences = jobResult?.confidences;
    const jobSectionTitleStyles = useJobSectionTitleStyles();
    return (React.createElement(React.Fragment, null,
        !!jobResult && (React.createElement(IdDocument, { jobErrors: jobErrors, jobRequestInfo: jobRequestInfo, jobRequestParams: jobRequestParams, jobRequestProperties: jobRequestProperties, jobResult: jobResult, jobStatus: jobStatus, rejectionReasons: rejectionReasons })),
        jobResult?.featuresEnabled?.crosscheckEnabled && (React.createElement(CrossCheckDropdowns, { crossCheckResult: crossCheckResult, crossCheckSubmittedData: crossCheckSubmittedData, jobErrors: jobErrors, jobStatus: jobStatus })),
        jobResult?.featuresEnabled?.dlvEnabled && jobResult.dlv && (React.createElement(DLVDropdown, { dlvJobResult: jobResult.dlv, dlvSubmittedData: {
                id: jobResult.id,
                state: jobResult.state,
                lastName: jobResult.lastName,
                birthDate: jobResult.birthDate,
                expirationDate: jobResult.expireDate
            }, jobStatus: jobStatus })),
        !jobResult?.featuresEnabled?.dlvEnabled &&
            jobResult?.featuresEnabled?.aamvaEnabled && (React.createElement(AAMVADropdowns, { aamvaJobResult: jobResult.aamva, country: jobResult.country, jobSid: jobSid, jobStatus: jobStatus })),
        jobResult?.aml && (React.createElement(AMLDropdowns, { isAMLOnly: false, jobAMLResults: jobResult.aml, jobErrors: jobErrors, jobSid: jobSid, jobStatus: jobStatus })),
        jobResult?.ipAddress && (React.createElement(IPDropdown, { ipAddressResults: {
                ...jobResult.ipAddress,
                address: jobRequestInfo?.ipaddress
            }, jobErrors: jobErrors, jobStatus: jobStatus })),
        React.createElement(Text, { style: jobSectionTitleStyles }, "Other"),
        job.nistCompliance?.ial2.crosscheck.linked && (React.createElement(NISTDropdown, { job: job, jobStatus: jobStatus })),
        (idAddress ?? ipAddress) && (React.createElement(LocationDropdowns, { crossCheckIpDistance: typeof crossCheckResult?.ip?.distance === 'number'
                ? `${crossCheckResult.ip.distance}`
                : '', idAddressStr: idAddress
                ? [
                    idAddress.streetNumber ?? '',
                    idAddress.street ?? '',
                    idAddress.city ?? '',
                    idAddress.state ?? '',
                    idAddress.country ?? ''
                ]
                    .join(' ')
                    .trim()
                : '', ipAddressStr: ipAddress
                ? [
                    ipAddress.city ?? '',
                    ipAddress.state ?? '',
                    ipAddress.country ?? ''
                ]
                    .join(' ')
                    .trim()
                : '', ipGeocode: ipAddress?.location
                ? {
                    lat: ipAddress.location.latitude,
                    lng: ipAddress.location.longitude
                }
                : undefined })),
        !!confidences && (React.createElement(ScoresDropdown, { barcodeMatch: roundNumber(confidences.barcodeMatch) ?? undefined, birthDateMatch: roundNumber(confidences.birthDateMatch) ?? undefined, expired: roundNumber(confidences.idExpired) ?? undefined, faceMatch: roundNumber(confidences.faceMatch) ?? undefined, id: roundNumber(confidences.id) ?? undefined, nameMatch: roundNumber(confidences.nameMatch) ?? undefined, selfie: roundNumber(confidences.selfie) ?? undefined })),
        !!confidences && (React.createElement(ReviewDropdowns, { dlvCheckPerformed: jobResult.dlv?.result?.wasCheckPerformed === true, jobConfidences: confidences, jobErrors: jobErrors, jobReview: jobReview, jobSid: jobSid, onReviewSubmitted: onReviewSubmitted, rejectionReasons: rejectionReasons })),
        filesDropdownVisible && React.createElement(FilesDropdown, { jobStatus: jobStatus }),
        debugDropdownVisible && (React.createElement(DebugDropdowns, { jobDebugResults: jobDebugResults })),
        debugDropdownVisible && React.createElement(RerunJobDropdown, { jobSid: jobSid })));
};
